import config from '../../config';

class GetMobileAppController {
  constructor(Authentication, PersonaCollection, $timeout, $scope, $rootScope) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection, $timeout, $scope, $rootScope });
  }

  $onInit() {
    if (!config.MOBILE_PHONE_POPUP_ENABLED) {
      return;
    }

    this.user = null;
    this.init();
  }

  async init() {
    await this.Authentication.userLoaded;
    await this.PersonaCollection.personaCollectionLoaded;
    await this.$timeout(3000);

    this.user = this.Authentication.user;
    this.saveClientFlags = this.Authentication.saveClientFlags;
  }

  get forceDisplay() {
    return this.$rootScope.forceMobileAppPopupDisplay || false;
  }

  async updatePhone(phoneData) {
    const updateUser = this.PersonaCollection.getShallowUserCopy(
      this.PersonaCollection.personasDict[this.user.id]
    );
    Object.assign(updateUser, phoneData);
    return updateUser.put({ 'user-fields': 'full' });
  }
}

export default {
  template: `
    <r-get-mobile-app-popup ng-if="!!ctrl.user"
      user="ctrl.user"
      save-client-flags="ctrl.saveClientFlags(flags)"
      force-display="ctrl.forceDisplay"
      on-close="ctrl.onClose()"
      update-phone="ctrl.updatePhone(phoneData)">
    </r-get-mobile-app-popup>
    `,
  controller: GetMobileAppController,
  controllerAs: 'ctrl',
};
